/**
 * UI symbols shared across components.
 */

export class UISymbols {
    public static PICKER_REMOVE = "✖";
    public static MODAL_CLOSE = "×";
    public static STAR_FILLED = "★";
}
